import { render } from "./Copyright.vue?vue&type=template&id=684aca78&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=684aca78&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-684aca78"

export default script